const StubVisibilityJs = {
  every: () => null,
  stop: () => null,
};

export default global.window === undefined ? StubVisibilityJs : require('visibilityjs');
